var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-2", attrs: { fluid: "" } },
    [
      !_vm.maintenance || !_vm.actions
        ? _c(
            "v-layout",
            {
              attrs: {
                "align-center": "",
                "justify-center": "",
                column: "",
                "fill-height": ""
              }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _c(
            "div",
            [
              _c(
                "v-layout",
                { staticClass: "mb-2", attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs10: "", "align-self-center": "" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "primary--text pb-2 mb-2",
                          staticStyle: {
                            "border-bottom": "2px solid #F92AC2",
                            "font-size": "20px",
                            "font-weight": "800"
                          }
                        },
                        [_vm._v(_vm._s(_vm.maintenance.name))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.maintenance.state != "done" &&
                  _vm.maintenance.state != "archived"
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-right",
                          attrs: { xs2: "", "align-self-center": "" }
                        },
                        [
                          _c(
                            "v-menu",
                            {
                              staticClass: "actions-menu__menu",
                              attrs: {
                                "offset-y": "",
                                bottom: "",
                                transition: "slide-x-transition",
                                "nudge-width": 250,
                                "close-on-content-click": false,
                                "content-class": "menu-content__block"
                              },
                              model: {
                                value: _vm.dtActionOpen,
                                callback: function($$v) {
                                  _vm.dtActionOpen = $$v
                                },
                                expression: "dtActionOpen"
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: _vm.dtActionOpen
                                          ? "secondary"
                                          : "primary"
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { dark: "" } }, [
                                        _vm._v("more_horiz")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                {
                                  staticClass:
                                    "actions-menu__list primary--text"
                                },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { disabled: !_vm.canEdit },
                                      on: { click: _vm.editMaintenance }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: _vm.canEdit
                                                  ? "primary"
                                                  : "greyLight"
                                              }
                                            },
                                            [_vm._v("edit")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        { class: { disabled: _vm.canEdit } },
                                        [
                                          _vm._v(
                                            "\n                Modifier\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "actions-menu__divider",
                                    attrs: { color: "fuchsia" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { disabled: !_vm.canAttachFile },
                                      on: { click: _vm.attachDocs }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-avatar",
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: _vm.canAttachFile
                                                  ? "primary"
                                                  : "greyLight"
                                              }
                                            },
                                            [_vm._v("attach_file")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        {
                                          class: { disabled: _vm.canAttachFile }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Ajouter un document\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "primary--text",
                      staticStyle: {
                        "border-radius": "0.5rem",
                        "margin-bottom": "1rem"
                      },
                      attrs: { color: "" }
                    },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c("v-flex", { attrs: { xs8: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "subheading font-weight-black"
                                  },
                                  [_vm._v(_vm._s(_vm.equipmentName))]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v("Référence : "),
                                  _c("b", [_vm._v(_vm._s(_vm.equipmentRef))])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right pt-1",
                                  staticStyle: { "font-size": "14px" },
                                  attrs: { "align-self-center": "", xs4: "" }
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.category) +
                                        " / " +
                                        _vm._s(_vm.subCategory)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "black--text",
                              attrs: {
                                "align-start": "",
                                "justify-space-between": "",
                                row: "",
                                "fill-height": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs4: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { shrink: "", "pr-2": "" } },
                                        [
                                          _c(
                                            "v-avatar",
                                            { attrs: { color: "primaryDark" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "white--text title"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getInitial(
                                                        _vm.manager.name
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { row: "" } }, [
                                        _c("div", { staticClass: "mb-2" }, [
                                          _c("div", [
                                            _c("b", [_vm._v("Responsable")])
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.manager.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "greyDarker--text" },
                                            [_vm._v(_vm._s(_vm.manager.role))]
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { shrink: "", "pr-2": "" } },
                                        [
                                          _c(
                                            "v-avatar",
                                            { attrs: { color: "primaryDark" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "white--text title"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getInitial(
                                                        _vm.contractor.name
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { row: "" } }, [
                                        _c("div", { staticClass: "mb-2" }, [
                                          _c("div", [
                                            _c("b", [_vm._v("Intervenant")])
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.contractor.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "greyDarker--text" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.contractor.role)
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { shrink: "", "pr-2": "" } },
                                        [
                                          _c(
                                            "v-avatar",
                                            { attrs: { color: "primaryDark" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "white--text title"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getInitial(
                                                        _vm.creator.name
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { row: "" } }, [
                                        _c("div", { staticClass: "mb-2" }, [
                                          _c("div", [
                                            _c("b", [_vm._v("Créée par")])
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.creator.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "greyDarker--text" },
                                            [_vm._v(_vm._s(_vm.creator.role))]
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      staticClass: "primary--text",
                      staticStyle: { "border-radius": "0.5rem" },
                      attrs: { flat: "", color: "backgroundList" }
                    },
                    [
                      _c("v-card-text", [
                        _c("div", { staticClass: "container-fluid" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2"
                              },
                              [
                                _c(
                                  "ul",
                                  { staticClass: "timeline timeline-centered" },
                                  _vm._l(_vm.sortedActions, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      {
                                        key: item.id,
                                        staticClass: "timeline-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "timeline-info" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pasreDate(item.createdAt)
                                                ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.pasreTime(
                                                      item.createdAt
                                                    )
                                                  )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "timeline-marker"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "timeline-content" },
                                          [
                                            _c(
                                              "v-card",
                                              {
                                                staticStyle: {
                                                  "border-radius": "1rem"
                                                },
                                                attrs: {
                                                  color: "greyLighter",
                                                  elevation: 1
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-card-text",
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      {
                                                        attrs: {
                                                          "align-start": "",
                                                          "justify-start": "",
                                                          reverse:
                                                            index % 2 === 1,
                                                          row: "",
                                                          "pb-0": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              shrink: ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                class: [
                                                                  index % 2 ===
                                                                  1
                                                                    ? "pl-2"
                                                                    : "pr-2"
                                                                ],
                                                                attrs: {
                                                                  large: "",
                                                                  color:
                                                                    "secondary"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .actionIcons[
                                                                      item
                                                                        .action_type
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              grow: "",
                                                              "align-self-center":
                                                                ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "primary--text"
                                                              },
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getActionTitle(
                                                                        item
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("div", [
                                                              _vm._v("Par "),
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getActionCreator(
                                                                      item.entity
                                                                    )
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " (" +
                                                                  _vm._s(
                                                                    _vm.getActionCreatorRole(
                                                                      item.entity
                                                                    )
                                                                  ) +
                                                                  ")"
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "caption"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Le " +
                                                                    _vm._s(
                                                                      _vm.pasreDate(
                                                                        item.createdAt
                                                                      )
                                                                    ) +
                                                                    " à " +
                                                                    _vm._s(
                                                                      _vm.pasreTime(
                                                                        item.createdAt
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.showDivider(
                                                  item.action_type
                                                )
                                                  ? _c("v-divider")
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.action_type ===
                                                "add_attachment"
                                                  ? _c(
                                                      "v-card-text",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "text-none turquoise primary--text",
                                                            attrs: {
                                                              round: "",
                                                              dark: "",
                                                              flat: "",
                                                              href:
                                                                item.document
                                                                  .link,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  left: "",
                                                                  dark: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "file_download"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "\n                                " +
                                                                _vm._s(
                                                                  item.document
                                                                    .name
                                                                ) +
                                                                "\n                              "
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.action_type ===
                                                "ticket_created"
                                                  ? _c(
                                                      "v-card-text",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "text-none turquoise primary--text",
                                                            attrs: {
                                                              round: "",
                                                              dark: "",
                                                              flat: "",
                                                              to:
                                                                item.action_value
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  left: "",
                                                                  dark: ""
                                                                }
                                                              },
                                                              [_vm._v("link")]
                                                            ),
                                                            _vm._v(
                                                              "\n                                Voir le ticket\n                              "
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.action_type ===
                                                "up_contractor_maintenance"
                                                  ? _c(
                                                      "v-card-text",
                                                      [
                                                        _c("timeline-history", {
                                                          attrs: {
                                                            oldLabel:
                                                              "Ancien intervenant",
                                                            newLabel:
                                                              "Nouveau intervenant",
                                                            oldValue:
                                                              item.previous_value,
                                                            newValue:
                                                              item.action_value
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.action_type ===
                                                "up_manager_maintenance"
                                                  ? _c(
                                                      "v-card-text",
                                                      [
                                                        _c("timeline-history", {
                                                          attrs: {
                                                            oldLabel:
                                                              "Ancien responsable",
                                                            newLabel:
                                                              "Nouveau responsable",
                                                            oldValue:
                                                              item.previous_value,
                                                            newValue:
                                                              item.action_value
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.action_type ===
                                                "up_name_maintenance"
                                                  ? _c(
                                                      "v-card-text",
                                                      [
                                                        _c("timeline-history", {
                                                          attrs: {
                                                            oldLabel:
                                                              "Ancien nom",
                                                            newLabel:
                                                              "Nouveau nom",
                                                            oldValue:
                                                              item.previous_value,
                                                            newValue:
                                                              item.action_value
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.action_type ===
                                                "up_description_maintenance"
                                                  ? _c(
                                                      "v-card-text",
                                                      [
                                                        _c("timeline-history", {
                                                          attrs: {
                                                            oldLabel:
                                                              "Ancienne description",
                                                            newLabel:
                                                              "Nouvelle description",
                                                            oldValue:
                                                              item.previous_value,
                                                            newValue:
                                                              item.action_value
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.action_type ===
                                                "update_attribute"
                                                  ? _c(
                                                      "v-card-text",
                                                      [
                                                        _c("timeline-history", {
                                                          attrs: {
                                                            oldLabel:
                                                              "Ancienne valeur",
                                                            newLabel:
                                                              "Nouvelle valeur",
                                                            oldValue:
                                                              item.previous_value +
                                                              " " +
                                                              item
                                                                .equipment_attribute_value
                                                                .attribute.unit,
                                                            newValue:
                                                              item.action_value +
                                                              " " +
                                                              item
                                                                .equipment_attribute_value
                                                                .attribute.unit
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "base-modal-duplicate",
                {
                  ref: "modal",
                  attrs: {
                    color: "backgroundGrey",
                    icon: _vm.coIcon,
                    "icon-type": "icon",
                    "max-width": "90%",
                    title: _vm.$t(_vm.dtRequestModal.translationKey),
                    "before-close": _vm.handleBeforeClose,
                    "submit-btn-title": _vm.$t(_vm.lblSetting.btnValidate),
                    "action-position": "center",
                    loading: _vm.buttonLoading
                  },
                  on: { onRecord: _vm.handleRecord },
                  model: {
                    value: _vm.dtRequestModal.visible,
                    callback: function($$v) {
                      _vm.$set(_vm.dtRequestModal, "visible", $$v)
                    },
                    expression: "dtRequestModal.visible"
                  }
                },
                [
                  _c("document-modal-vertical", { attrs: { isTicketChat: "" } })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c5c4e8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c5c4e8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-maintenance-detail/template.html
// module id = null
// module chunks = 